export default {
      id: "i-search-3-usage",
      viewBox: "0 0 1438 408",
      url: __webpack_public_path__ + "img/sprite.svg#i-search-3",
      toString: function () {
        return this.url;
      }
    }